import { loadableWithRetry } from '../../common/utils/lazyLoad'

const routes = [
  {
    // No `name` so CheckAccess falls through to the logged-in-only check; the
    // container gates on the `role_notification_settings_override` permission
    // and redirects unauthorized users away.
    path: '/',
    exact: true,
    component: loadableWithRetry(() => import('./NotificationSettingsContainer')),
  },
]

export default routes
